import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserAuth } from "@/user/UserAuthContext";
import { useLanguage, langPrefix } from "@/i18n/LanguageContext";

const L = {
  ar: { loading: "جارٍ التحقق من الجلسة\u2026" },
  en: { loading: "Checking your session\u2026" },
};

/**
 * Guards `/account` (and any future protected user-facing route).
 *  - "loading" -> minimal inline placeholder (no layout jump)
 *  - unauthenticated -> redirect to `/<lang>/auth/login`, remembering origin
 */
export default function UserProtectedRoute() {
  const { status } = useUserAuth();
  const { lang } = useLanguage();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div
        className="min-h-[50vh] flex items-center justify-center"
        data-testid="user-protected-loading"
      >
        <div className="text-sm text-[color:var(--sas-ink-2)]">{L[lang].loading}</div>
      </div>
    );
  }

  if (status !== "authenticated") {
    return (
      <Navigate
        to={`${langPrefix(lang)}/auth/login`}
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
}
